import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { map } from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';
import { Page } from '../model/Page';
import { Observable } from 'rxjs';
import { ResourcesDTO } from '../model/ResourcesDTO';
import { EnumDTO } from '../model/EnumDTO';
import { CategoryDTO } from '../model/CategoryDTO';


@Injectable({
    providedIn: 'root'
})
export class ResourceService {

    private BASE_URL = '/Resource';
    private ALL = '/all';
    private DELETE_MANY = '/deletemany'
    private TYPES = '/resourcesTypes'
    private LEVELS = '/resourcesLevels'
    private CATEGORIES = '/resourcesCategories'

    constructor(private http: HttpService) { }

    getResourceTypes(): Observable<EnumDTO[]> {
        return this.http.get<EnumDTO[]>(this.BASE_URL + this.TYPES).pipe(
            map(response => {
                let results = response.map(item => {
                    var data = new EnumDTO();
                    data.fillFromJSON(item);
                    return data;
                })
                return results;
            })
        );
    }

    getResourceLevels(): Observable<EnumDTO[]> {
        return this.http.get<EnumDTO[]>(this.BASE_URL + this.LEVELS).pipe(
            map(response => {
                let results = response.map(item => {
                    var data = new EnumDTO();
                    data.fillFromJSON(item);
                    return data;
                })
                return results;
            })
        );
    }

    getResourceCategories(): Observable<CategoryDTO[]> {
        return this.http.get<CategoryDTO[]>(this.BASE_URL + this.CATEGORIES).pipe(
            map(response => {
                let results = response.map(item => {
                    var data = new CategoryDTO();
                    data.fillFromJSON(item);
                    return data;
                })
                return results;
            })
        );
    }

    getById(id: string): Observable<ResourcesDTO> {
        return this.http.get<ResourcesDTO>(this.BASE_URL + '/' + id.toString()).pipe(
            map(response => {
                var data = new ResourcesDTO();
                data.fillFromJSON(response);
                return data;
            })
        );
    }

    getAll(text?: string): Observable<ResourcesDTO[]> {
        var httpParams = new HttpParams();
        if (text) {
            httpParams = httpParams.append('searchKey', text);
        }
        return this.http.get<ResourcesDTO[]>(this.BASE_URL + this.ALL, httpParams).pipe(
            map(response => {
                let results = response.map(item => {
                    var data = new ResourcesDTO();
                    data.fillFromJSON(item);
                    return data;
                })
                return results;
            })
        );
    }

    getList(currentPage: number, pageSize: number, text: string, keyDriverId?: string): Observable<Page<ResourcesDTO>> {
        var httpParams = new HttpParams();
        httpParams = httpParams.append('currentPage', currentPage.toString());
        httpParams = httpParams.append('pageSize', pageSize.toString());
        if (text) {
            httpParams = httpParams.append('searchKey', text);
        }
        if (keyDriverId) {
            httpParams = httpParams.append('keyDriverId', keyDriverId);
        }
        return this.http.get<Page<ResourcesDTO>>(this.BASE_URL, httpParams).pipe(
            map(response => {
                var obj = new Page<ResourcesDTO>();
                obj.currentPage = response.currentPage;
                obj.length = response.length;
                obj.pageSize = response.pageSize;
                obj.results = response.results.map(item => {
                    var data = new ResourcesDTO();
                    data.fillFromJSON(item);
                    return data;
                })
                return obj;
            })
        );
    }

    create(data: ResourcesDTO): Observable<any> {
        return this.http.post<ResourcesDTO>(this.BASE_URL, null, data);
    }

    update(data: ResourcesDTO): Observable<any> {
        return this.http.put<ResourcesDTO>(this.BASE_URL, data);
    }

    deleteMany(ids: string[]): Observable<any> {
        return this.http.post<any>(this.BASE_URL + this.DELETE_MANY, null, ids);
    }

}
